<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">库存清点</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label">门店/仓存</div>
            <el-select
              filterable
              v-model="md"
              placeholder="请选择门店"
              style="width: 100%"
              clearable
            >
              <el-option
                v-for="item in menlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="label">品名</div>
            <el-select
              v-model="pmname"
              placeholder="请选择品名"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in pmlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="label">数量</div>
            <el-input v-model="num" clearable style="width: 180px"></el-input>
            -
            <el-input v-model="nums" clearable style="width: 180px"></el-input>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button
                size="small"
                type="primary"
                class="custom-btn"
                @click="search"
                >查询</el-button
              >
            </div>
            <div class="form-options">
              <el-button
                size="small"
                type="primary"
                class="custom-btn"
                @click="saves"
                >保存</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%" class="custom-table">
      <el-table-column align="center" prop="storeName" label="门店/仓存" />
      <el-table-column
        align="center"
        prop="productName"
        label="品名"
        show-overflow-tooltip
      />
      <el-table-column align="center" prop="number" label="库存数量" />
      <!-- 调整后库存（前端输入） -->
      <el-table-column align="center" label="调整后库存数量">
        <template #default="scope">
          <el-input
            v-model.number="scope.row.rectifyNumber"
            placeholder="请填入"
            @input="handleCalcDiff(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <!-- 调整差额（自动计算） -->
      <el-table-column align="center" prop="changeNumber" label="调整差额">
        <template #default="scope">
          {{ scope.row.changeNumber || "" }}
        </template>
      </el-table-column>

      <!-- ========== 加载更多插槽 和色卡页面完全一样 ========== -->
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
  </div>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();
const num = ref("");
const nums = ref("");
const list = ref([]);
const pmname = ref("");
const pmlist = ref([]);
const md = ref("");
const menlist = ref([]);

// ========= 新增分页变量，和色卡码页面保持一致 =========
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardStockRectify";

// 监听查询条件
watch([md, pmname, num, nums], () => {
  const searchParams = {
    md: md.value,
    pmname: pmname.value,
    num: num.value,
    nums: nums.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      md.value = cache.md ?? "";
      pmname.value = cache.pmname ?? "";
      num.value = cache.num ?? "";
      nums.value = cache.nums ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

// 计算方式：调整后库存 - 原始库存
const handleCalcDiff = (row) => {
  if (!row.rectifyNumber && row.rectifyNumber !== 0) {
    row.changeNumber = "";
    return;
  }
  const diff = Number((row.rectifyNumber - row.number).toFixed(2));
  row.changeNumber = diff;
};
const saves = async () => {
  const updateList = list.value
    .filter(
      (item) => item.rectifyNumber !== undefined && item.rectifyNumber !== ""
    )
    .map((item) => ({
      storeId: item.storeId,
      productId: item.productId,
      number: item.rectifyNumber,
    }));
  if (updateList.length === 0) {
    proxy.$message.warning("请先输入调整后库存数量");
    return;
  }
  try {
    const res = await proxy.$api.Colorcard.sopupdate({
      colorcardStockList: updateList,
    });
    if (res.data.code == 200) {
      proxy.$message.success("保存成功");
      // 保存成功，重置到第一页刷新
      pages.value.page = 1;
      noMore.value = false;
      list.value = [];
      getList();
    } else {
      proxy.$message.error("保存失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("保存异常：", error);
    proxy.$message.error("网络错误，保存失败");
  }
};
// 门店列表
const mdList = async () => {
  try {
    const res = await proxy.$api.Colorcard.get({});
    if (res.data.code == "200") {
      menlist.value = res.data.data.list.filter(
        (item) => item.name !== "" && item.name !== null
      );
    } else {
      proxy.$message.error("获取门店列表失败");
      menlist.value = [];
    }
  } catch (error) {
    console.error("获取门店列表异常：", error);
    menlist.value = [];
  }
};
// 产品列表
const pmList = async () => {
  try {
    const res = await proxy.$api.Colorcard.gets({});
    if (res.data.code == "200") {
      pmlist.value = res.data.data.list;
    } else {
      pmlist.value = [];
    }
  } catch (error) {
    console.error("获取产品列表异常：", error);
    pmlist.value = [];
  }
};

// ========= 查询：重置页码、清空列表 =========
const search = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};

// ========= 加载下一页 =========
const loadMore = async () => {
  await getList(true);
};

// ========= 改造 getList，支持 isLoadMore 追加逻辑，和色卡页面一模一样 =========
const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    storeId: md.value,
    productId: pmname.value,
    minNumber: num.value,
    maxNumber: nums.value,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.Colorcard.getsop(sendata);
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      // 给新数据初始化 rectifyNumber、changeNumber
      currentData.forEach((item) => {
        item.rectifyNumber = "";
        item.changeNumber = "";
      });

      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }

      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;

      pages.value.page += 1;
    } else if (!isLoadMore) {
      list.value = [];
      proxy.$message.error("获取列表失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("获取列表异常：", error);
    if (!isLoadMore) list.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  pmList();
  mdList();
  loadSearchCache(); //回填
  getList();
});
</script>
<style lang="scss" scoped>
@import "./colorcardStockRectify..scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
:deep(.el-dialog) {
  margin-top: 15vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 180px;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
/* 和色卡页面复用的加载更多样式，加到这里 */
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
</style>
<style>
.publish-btn {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333 !important;
  font-weight: 500;
}
</style>
